import React from "react";
import { IImageViewerModalProps } from "./ImageViewerModal.types";
import { LazyLoadWrapper } from "../LazyLoadWrapper";

const ImageViewerModal = React.lazy(() => import("./ImageViewerModal"));

const LazyLoadedImageViewerModal = (props: IImageViewerModalProps) => {
  const { isOpen } = props;
  return (
    <LazyLoadWrapper loadingCondition={isOpen}>
      <ImageViewerModal {...props} />
    </LazyLoadWrapper>
  );
};

export default LazyLoadedImageViewerModal;
